module.exports = __webpack_public_path__ + "img/TRON.760fdf0a.png";